import Head from "next/head";
import { useEffect } from "react";
import { Box } from "@mui/material";

import { MemoizedFooter } from "../src/layouts/footer";
import { MemoizedHeader } from "../src/layouts/header";
import { MemoizedContactUs } from "../src/modules/ContactUs/contactUs";
import Breadcrumbs from "../src/components/common/Breadcrumbs";
import { sendAnalytics } from "../src/utils/analyticsCommon";

export default function ContactUs() {
  const BREADCRUMB_ITEMS = [
    { label: "Home", href: "/" },
    { label: "Contact Us" },
  ];

  const BREADCRUMB_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.turno.club/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Contact Us",
        item: "https://www.turno.club/contactus",
      },
    ],
  };

  useEffect(() => {
    sendAnalytics("screen_viewed", { screen_name: "contact-us" }, "en");
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <Head>
        <title>Contact Turno for all your electric load vehicle queries</title>
        <meta
          name="description"
          content="Want to get the best offer on electric vehicles in India? Call Turno EV experts and get the best discount on commercial electric vehicles. "
        />
        <meta
          name="keywords"
          content="Turno, Turno customer care, customer support, contact us page, contact us, contact page, Electric Three Wheeler, EV, EVs, electric auto, ev in india, auto gadi"
        />
        <meta name="author" content="Turno" />
        <meta name="url" content="https://www.turno.club/contactus" />

        <meta name="robots" content="INDEX,ARCHIVE,FOLLOW" />
        <meta name="lang" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Facebook */}
        <meta property="og:url" content="https://www.turno.club/contactus" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Contact Turno for all your electric load vehicle queries"
        />
        <meta
          property="og:description"
          content="Want to get the best offer on electric vehicles in India? Call Turno EV experts and get the best discount on commercial electric vehicles."
        />
        <meta property="og:image" content="/logoIcon.png" />
        <meta property="fb:app_id" content="5796260583761767" />
        <meta property="fb:pages" content="646488286564232" />
        {/* Twitter */}
        <meta
          name="twitter:description"
          content="Want to get the best offer on electric vehicles in India? Call Turno EV experts and get the best discount on commercial electric vehicles."
        />
        <meta
          name="twitter:title"
          content="Contact Turno for all your electric load vehicle queries"
        />
        <meta name="twitter:site" content="@Turno" />
        <meta name="twitter:creator" content="@Turno" />
        <meta name="twitter:url" content="https://www.turno.club/contactus" />
        <meta
          name="twitter:app:id:googleplay"
          content="com.customerapp.turno.turno_customer_application"
        />
        <meta name="twitter:app:country" content="IN" />

        <link rel="canonical" href="https://www.turno.club/contactus" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
      </Head>

      <MemoizedHeader />
      <MemoizedContactUs />
      <Box sx={{ width: { xs: "100%", md: "84%" }, margin: "20px auto", padding: { xs: "0 12px", md: "0" } }}>
        <Breadcrumbs items={BREADCRUMB_ITEMS} />
      </Box>
      <MemoizedFooter />
    </>
  );
}
